import React from "react";
import { useTranslation } from "next-i18next";

import {
  YoutubeFeeds,
  TwitterFeeds,
  FacebookFeeds,
  PinterestFeeds,
  InstagramFeeds
} from "@/shared/components/feeds";

const Feeds = () => {
  const { t } = useTranslation();

  return (
    <div className="feeds-container-wrapper">
      <TwitterFeeds t={t} />
      <InstagramFeeds t={t} />
      <FacebookFeeds t={t} />
      <PinterestFeeds t={t} />
      <YoutubeFeeds t={t} />
    </div>
  );
};

export default Feeds;
